import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import { Modal, Tooltip, Alert } from 'bootstrap';

import '../components/axios.js';
import { getPublicUrl, getWwwUrl } from '../components/utils.js';
import ReCaptchaService from '../services/recaptcha-service.js';

window.dataLayer = window.dataLayer || [];

class ReviewInvite {
	constructor() {
		window.reCaptchaService = this.reCaptchaService = new ReCaptchaService();
		this.reCaptchaService.init(); // TODO: it can be deleted after public.js isn't used anymore

		this.form = document.getElementById('write-review');
		if (!this.form) {
			return;
		}

		this.submitButton = this.form.querySelector('.btn-submit');
		this.negativeLink = document.querySelector('.btn-negative-review');
		this.name = document.getElementById('sender-name');
		this.textarea = document.getElementById('support-text');
		this.notificationSuccess = document.getElementById('notification-success');

		this.form.addEventListener('submit', this.handleSubmit.bind(this));
	}

	handleSubmit(event) {
		event.preventDefault();

		this.submitButton.blur();
		this.textarea.classList.remove('is-invalid');

		const text = this.textarea.value.trim();
		if (text === "") {
			this.textarea.classList.add('is-invalid');
			this.textarea.focus();
			return;
		}

		this.toggleLoadingAnimation(true);
		this.submitButton.disabled = true;

		reCaptchaService.runWithCaptcha(
			"company_review_support",
			(token, withCheckbox = false) => {
				const url = getPublicUrl() + '/api' + window.location.href.replace(getPublicUrl(), '').replace(getWwwUrl(), '').replace('/v2', '').split('?')[0];
				return axios.post(url, {
					text: text,
					name: this.name.value.trim(),
					recaptcha_token: token,
					recaptcha_checkbox: withCheckbox,
				})
				.then(response => {
					console.log("company_review_support", response);
					this.form.style.display = 'none';
					this.negativeLink.style.display = 'none';
					this.notificationSuccess.style.display = 'block';
				})
				.catch(error => {
					console.error("company_review_support", error);
					this.toggleLoadingAnimation(false);
					this.submitButton.disabled = false;
				});
			}
		);
	}

	toggleLoadingAnimation(isLoading) {
		console.log('toggleLoadingAnimation', isLoading, this.submitButton);
		if (isLoading) {
			this.submitButton.classList.add('loading');
		} else {
			this.submitButton.classList.remove('loading');
		}
	}
}

document.addEventListener('DOMContentLoaded', () => {
	new ReviewInvite();
});